// eslint-disable-next-line
export default {
    fontFamily: ["Cairo", "Roboto", '"Helvetica Neue"', "sans-serif"].join(","),
    h1: {
        fontWeight: 500,
        fontSize: 60,
    },
    h2: {
        fontWeight: 500,
        fontSize: 50,
    },
    h3: {
        fontWeight: 500,
        fontSize: 40,
    },
    h4: {
        fontWeight: 500,
        fontSize: 30,
    },
    h5: {
        fontWeight: 500,
        fontSize: 25,
    },
    h6: {
        fontWeight: 500,
        fontSize: 20,
    },
    overline: {
        fontWeight: 500,
    },
    body1: {
        fontWeight: 300,
        fontSize: 18,
    },
    body2: {
        fontWeight: 300,
        fontSize: 18,
    },
};
